import axiosInstance, { axiosInstanceImage, onRequestError } from "@helper/interceptor";
// import { onRequest } from "../../Projects/services/projectCrud";

export const getAllCustomers = async () => {
  let response = await axiosInstance.get("customers");
  return response.data;
};
export const getCustomerBasicInfo = async () => {
  let response = await axiosInstance.get("customer-basic-info");
  return response.data;
};
export const getCustomer = async (id) => {
  let response = await axiosInstance.get(`customers/${id}`);
  return response.data;
};
export const createCustomer = async ({ values }) => {
  console.log("createCustomer API called with:", values);
  console.log("Posting to: customers/");
  try {
    const res = await axiosInstance.post("customers/", values);
    console.log("createCustomer API response:", res.data);
    return res.data;
  } catch (error) {
    console.error("createCustomer API error:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    throw error;
  }
};

export const updateCustomer = async ({ values, id }) => {
  const res = await axiosInstance.patch(`customers/${id}/`, values);
  return res.data;
};
export const addCustomerImage = async ({ form, pId }) => {
  // Use dedicated image instance for file uploads
  let response = await axiosInstanceImage.post(`upload-image`, form);
  return response.data;
};
